import { useQuery } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import { IPurchaseOrderDetail } from 'services/BookingManagerApi/types/PurchaseOrdersSearchResponse';

export const PURCHASE_ORDER_DETAIL_QUERY_KEY = 'purchaseOrderDetail';

export const usePurchaseOrderDetailQuery = (bookingUuid: string, purchaseOrderCode: string | undefined) => {
  return useQuery<IPurchaseOrderDetail>({
    queryKey: [PURCHASE_ORDER_DETAIL_QUERY_KEY, bookingUuid, purchaseOrderCode],
    queryFn: async () => {
      const api = makeBookingManagerApi();
      const response = await api.getPurchaseOrderByCode(bookingUuid, purchaseOrderCode);
      return response.data;
    },
    enabled: !!bookingUuid,
  });
};
